// extracted by mini-css-extract-plugin
module.exports = {"simulatorContainer":"JobSimulator_simulatorContainer__2MhXT","paramInput":"JobSimulator_paramInput__3tR3p","input":"JobSimulator_input__3mNxS"};